/**
 * Generated runtime TestId mirror for frontend/src/pages/reporting/ParameterForm.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ParameterFormTestIds = {
  parameterForm: "parameter-form",
  param: (param_name: string) => `param-${param_name}`,
  paramPrefix: () => "param-" as TestIdPrefix
} as const;
